<div
  [ngClass]="{ 'widget-item--clickable': item.actionRoute }"
  (click)="goToPage()"
  class="widget-item"
>
  <div class="widget-item__top">
    <span [title]="item.title" class="widget-item__title line-clamp-1">{{
      item.title
    }}</span>
    @if(item.subInfo) {
    <span class="widget-item__tag tag">{{ item.subInfo }}</span>
    }
  </div>
  <div class="widget-item__middle">
    <div class="widget-item__middle-top">
      @if(item.description) {
      <span class="line-clamp-2">
        {{ item.description }}
      </span>
      } @if(item.actionTitle) {
      <button class="btn btn--ssm btn--no-bg widget-item__button">
        <span>{{ item.actionTitle | translate }} </span>
      </button>
      }
    </div>

    <ng-content></ng-content>
  </div>
</div>
